import type { YmmFormState } from './state';
import type { YmmFormAction } from '../store/actions';
import { YMM_FIELDS } from './constants';

export function ymmFormReducer(
  state: YmmFormState,
  action: YmmFormAction
): YmmFormState {
  switch (action.type) {
    case 'SET_LOADING':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.field]: action.isLoading,
        },
      };

    case 'SET_ERROR':
      return {
        ...state,
        error: action.error,
      };

    case 'SET_FIELDS':
      const newFormData = { ...state.formData };
      action.fields.forEach((field) => {
        switch (field.name) {
          case YMM_FIELDS.YEAR:
            newFormData.year = field;
            break;
          case YMM_FIELDS.MAKE:
            newFormData.make = field;
            break;
          case YMM_FIELDS.MODEL:
            newFormData.model = field;
            break;
        }
      });
      return {
        ...state,
        formData: newFormData,
      };

    case 'SET_YEAR':
      return {
        ...state,
        fieldState: {
          ...state.fieldState,
          year: {
            ...state.fieldState.year,
            current_val: action.value,
          },
        },
      };

    case 'SET_MAKE':
      return {
        ...state,
        fieldState: {
          ...state.fieldState,
          make: {
            ...state.fieldState.make,
            current_val: action.value,
          },
        },
      };

    case 'SET_MODEL':
      return {
        ...state,
        fieldState: {
          ...state.fieldState,
          model: {
            ...state.fieldState.model,
            current_val: action.value,
          },
        },
      };

    case 'RESET_DEPENDENT_FIELDS':
      if (action.field === 'year') {
        return {
          ...state,
          formData: {
            ...state.formData,
            make: { ...state.formData.make, options: [] },
            model: { ...state.formData.model, options: [] },
          },
          fieldState: {
            ...state.fieldState,
            make: { ...state.fieldState.make, current_val: '' },
            model: { ...state.fieldState.model, current_val: '' },
          }
        }
      }
      if (action.field === 'make') {
        return {
          ...state,
          formData: {
            ...state.formData,
            model: { ...state.formData.model, options: [] },
          },
          fieldState: {
            ...state.fieldState,
            model: { ...state.fieldState.model, current_val: '' },
          }
        };
      }
      return state;

    case 'UPDATE_FIELD_OPTIONS':
      const updatedFormData = { ...state.formData };
      switch (action.fieldName) {
        case YMM_FIELDS.MAKE:
          updatedFormData.make = {
            ...updatedFormData.make,
            options: action.options,
          };
          break;
        case YMM_FIELDS.MODEL:
          updatedFormData.model = {
            ...updatedFormData.model,
            options: action.options,
          };
          break;
      }
      return {
        ...state,
        formData: updatedFormData,
      };

    case 'RESET_FIELDS':
      return {
        ...state,
        fieldState: {
          ...state.fieldState,
          year: { ...state.fieldState.year, current_val: '' },
          make: { ...state.fieldState.make, current_val: '' },
          model: { ...state.fieldState.model, current_val: '' },
        },
      };

    case 'SET_PRESERVE_FROM_RESTORE':
      return {
        ...state,
        preserveFromRestore: action.value,
      };

    case 'SET_APP_DISABLED':
      return {
        ...state,
        appDisabled: action.value,
        disabledMessage: action.message,
      };

    default:
      return state;
  }
}
